export const favoritesTab = {
    name: 'Избранное',
    type: 'favorites',
    icon: 'heart',
    activity_types: items => items
        ?.map(el => el.activity_types)
        ?.flat()
        ?.filter(el => el.bookmark),
};
